import { Component, Input } from '@angular/core';

@Component({
  selector: 'pl-burger-menu-button',
  templateUrl: './burgerMenuButton.component.html',
  styleUrls: ['./burgerMenuButton.component.scss'],
})
export class BurgerMenuButtonComponent {
  @Input() public isMenuOpen: boolean = false;
}
